import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Button from '@ids/button';

import ImgLeaderLineGreen from '../../../assets/images/ic-4px-leader-line-green.svg';
import { convertToSnakeCase, getImageSrc } from '../Util/CommonUtils';

const SmoothRunningBusinessSupplies = (props) => {
  return (
    <div className="SmoothRunningBusinessSupplies">
      <div className="container-center-lg">
        <div>
          <h2 className="text-align-center font-weight-700 margin-container-20">{props.title}</h2>
          <div className="row SmoothRunningBusinessSuppliesProductWrap">
            {props.products.map((product, index) => {
              return (
                <div
                  className="col-xs-12 col-md-4 SmoothRunningBusinessSuppliesProduct"
                  key={index}
                >
                  <h4 className="font-weight-700">{product.productName}</h4>
                  <img
                    src={getImageSrc(ImgLeaderLineGreen)}
                    className="line-separator"
                    alt="..."
                    loading="lazy"
                  />
                  <div className="SmoothRunningBusinessSupplies-image-wrapper">
                    <picture>
                      <source
                        className="product-image SmoothRunningBusinessSupplies-image"
                        loading="lazy"
                        height={product.ImageHeight ? product.ImageHeight : 'auto'}
                        width={product.ImageWidth ? product.ImageWidth : 'auto'}
                        alt={product.productName}
                        srcset={getImageSrc(product?.ImageSrcOptimized)}
                        type="image/webp"
                      />
                      <img
                        className="product-image SmoothRunningBusinessSupplies-image"
                        loading="lazy"
                        height={product.ImageHeight ? product.ImageHeight : 'auto'}
                        width={product.ImageWidth ? product.ImageWidth : 'auto'}
                        alt={product.productName}
                        src={getImageSrc(product.productImage)}
                      />
                    </picture>
                  </div>
                  <Link
                    to={product.learnMoreLink}
                    data-wa-link={`learn more:${product.learnMoreLink}`}
                  >
                    <Button
                      theme="quickbooks"
                      buttonType="primary"
                      className="SmoothRunningBusinessSupplies-btn"
                      data-ui-object="button"
                      data-refer-ui-access-point={`learn_more_about | ${convertToSnakeCase(
                        product.learnMoreLink,
                      )}`}
                    >
                      Learn more
                    </Button>
                  </Link>
                  <div className="product-features">
                    <ul>
                      {product.productFeatures.map((feature, index) => {
                        return <li key={index}>{feature}</li>;
                      })}
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

SmoothRunningBusinessSupplies.propTypes = {
  title: PropTypes.string,
  products: PropTypes.array,
};

export default SmoothRunningBusinessSupplies;
